export const removeEmptyQuery = (query: any) => {
  for (const queryKey of Object.keys(query)) {
    if (query[queryKey] === '') {
      query[queryKey] = undefined;
    }
  }
  return query;
};
